import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("useen_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("useen_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("useen_token", data.token);
    // Pull full /auth/me payload so we get limits + usage on first render
    try {
      const me = await api.get("/auth/me");
      setUser(me.data);
      return me.data;
    } catch {
      setUser(data.user);
      return data.user;
    }
  };

  const register = async (payload) => {
    // payload is the full registration body (full_name, email, password, kvkk_acknowledged, ...)
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("useen_token", data.token);
    try {
      const me = await api.get("/auth/me");
      setUser(me.data);
      return me.data;
    } catch {
      setUser(data.user);
      return data.user;
    }
  };

  const logout = () => {
    localStorage.removeItem("useen_token");
    setUser(null);
  };

  const isAdmin = !!user && user.role === "admin";
  const plan = user?.plan || "free";
  const limits = user?.limits || null;
  const usage = user?.usage || null;
  const refreshUser = async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      return r.data;
    } catch {
      return null;
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, isAdmin, plan, limits, usage, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
